const requiredQuestions = [
    {
        id: "position",
        title: "What Position Are You Applying For *",
        type: "radio",
        options: [
            {name: "AD", label: "AD"},
            {name: "CW", label: "CW"},
            {name: "DES", label: "DES"},
            {name: "DS", label: "DS"}
        ],
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "firstName",
        title: "First Name *",
        type: "text",
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "lastName",
        title: "Last Name *",
        type: "text",
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "email",
        title: "Email *",
        type: "text",
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "phone",
        title: "Phone *",
        type: "text",
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "resume",
        title: "Resume *",
        type: "file",
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "coverletter",
        title: "Cover Letter",
        type: "file",
        required: true,
        value: "",
        actuallyRequired: false
    },
    {
        id: "howdidyouhear",
        title: "How did you hear about Swift? *",
        type: "text",
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "authorizedinus",
        title: "Are you authorized to work in the US? *",
        type: "radio",
        options: [
            { name: "yes", label: "Yes" },
            { name: "no", label: "No" }
        ],
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "wppagency",
        title: "Have you worked for a WPP agency in the last 10 years? *",
        type: "radio",
        options: [
            { name: "yes", label: "Yes" },
            { name: "no", label: "No" }
        ],
        required: true,
        value: "",
        actuallyRequired: true
    },
    {
        id: "linkedin",
        title: "Linkedin Profile",
        type: "text",
        value: "",
        required: true,
        actuallyRequired: false
    },
    {
        id: "portfolio",
        title: "PORTFOLIO SITE (PDF? Upload it to Google Drive and share the link.)",
        type: "text",
        value: "",
        required: true,
        actuallyRequired: false
    },
    {
        id: "pronouns",
        title: "What are your pronouns?",
        type: "text",
        value: "",
        required: true,
        actuallyRequired: false
    },
    {
        id: "accommodations",
        title: "Do you require any accommodations throughout your interview experience? For example: wheelchair accessibility, mother's room, etc.?",
        type: "text",
        value: "",
        required: true,
        actuallyRequired: false
    },
    {
        id: "demographics_gender",
        title: "Gender",
        type: "radio",
        options: [
            { name: "male", label: "Male" },
            { name: "female", label: "Female" },
            { name: "nonbinary", label: "Non-binary" },
            { name: "optout", label: "I choose not to self-identify" },
            { name: "other", label: "Other" },
        ],
        value: "",
        required: true,
        actuallyRequired: false,
        demographic: true
    },
    {
        id: "demographics_gender__other",
        title: "If you selected \"other\", please specify",
        type: "text",
        value: "",
        required: true,
        actuallyRequired: false,
        demographic: true
    },
    {
        id: "demographics_race",
        title: "Race (select all that apply)",
        type: "checkbox",
        options: [
            { name: "hispaniclatinx", label: "Hispanic or Latinx" },
            { name: "blackafricanamerican", label: "Black or African American" },
            { name: "nativehawaiianotherpacificislander", label: "Native Hawaiian or Other Pacific Islander" },
            { name: "white", label: "White" },
            { name: "eastasian", label: "East Asian" },
            { name: "southasian", label: "South Asian" },
            { name: "nativeamericanalaskannative", label: "Native American or Alaskan Native" },
            { name: "optout_race", label: "I choose not to self-identify" },
        ],
        value: [],
        required: true,
        actuallyRequired: false,
        demographic: true
    },
];

/*
    Question example:
    {
        id: "#",
        title: "How do you make an entrace?",
        type: "radio", // (textarea, radio)
        align: "left", // (left, center, right)
        belowSpacing: "medium", // (low, medium, high)
        value: "", // leave blank
        options: [ // option objects
            { name: "name", label: "Name" },
            { name: "name", label: "Name" },
        ],
        customClass: "class1 class2", // custom class on .questionbox container
        required: false, // (true, false)
        sticker: { // sticker options
            positionX: "left", // (left, right, center)
            positionY: "above", // (above, below, none)
            bleed: true, // (true, false)
            fileName: "001_Upside-Down-Smiley-Face.png",
            rotate: -40 // in degrees
        }
    }
*/
const otherQuestions = [
    {
        id: "1",
        title: "How do you make an entrance?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "2",
        title: "Reply to this text.",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: "",
        customClass: "monkey-cactus",
        sticker: {
            positionX: "left",
            positionY: "none",
            bleed: false,
            fileName: "000_Potato-Chip-Flying-Yoga.png"
        }
    },
    {
        id: "3",
        title: "You can make any Giphy sticker you want. Describe it.",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "above",
            bleed: true,
            fileName: "004_Jelly-Gummies.gif",
            rotate: 40
        }
    },
    // {
    //     id: "4",
    //     title: "What's your Twitter handle?",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "low",
    //     value: "",
    //     sticker: {
    //         positionX: "right",
    //         positionY: "above",
    //         bleed: false,
    //         fileName: "005_Dancing-Head.gif",
    //     }
    // },
    // {
    //     id: "5",
    //     title: "Share your favorite TikTok video with us. Copy and paste the link.",
    //     type: "textarea",
    //     align: "right",
    //     belowSpacing: "medium",
    //     value: "",
    //     sticker: {
    //         positionX: "left",
    //         positionY: "none",
    //         bleed: false,
    //         fileName: "006_Person-Dancing.gif"
    //     }
    // },
    {
        id: "6",
        title: "What's your favorite font?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    // {
    //     id: "7",
    //     title: "Are you having fun so far?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: "",
    //     customClass: "julius",
    //     sticker: { // sticker options
    //         positionX: "center",
    //         positionY: "above",
    //         bleed: false,
    //         fileName: "007_Slightly-Smiling-Julius.gif"
    //     }
    // },
    {
        id: "8",
        title: "The Blazers need a new mascot. What should it be?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "below",
            bleed: true,
            fileName: "008_Portland-Signage.png"
        }
    },
    {
        id: "9",
        title: "You're an Instagram influencer. What do you post?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "10",
        title: "Give yourself a job title.",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "below",
            bleed: true,
            fileName: "035_Potato-With-Tongue.png",
            rotate: -20
        }
    },
    // {
    //     id: "checkpoint1",
    //     title: "You can submit whenever you want. Or don’t want.",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "above",
    //         fileName: "Dope Giphy.gif",
    //         bleed: false
    //     }
    // },
    {
        id: "11",
        title: "What's the GREATEST THING about Monday?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "12",
        title: "Name your own ice cream flavor.",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: true,
            fileName: "009_Icecream.png",
            rotate: -40
        }
    },
    {
        id: "13",
        title: "What's your next Pinterest board for?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "14",
        title: "Create a new #holiday.",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "16",
        title: "You're in charge of the office playlist for the day. What's up first?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "above",
            bleed: true,
            fileName: "010_Ear.png"
        }
    },
    {
        id: "17",
        title: "What's the most useless piece of information you know?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "18",
        title: "What does the color cyan make you think of?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "19",
        title: "Create an alias for yourself.",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    // {
    //     id: "20",
    //     title: "Why advertising?",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "higher",
    //     value: "",
    //     sticker: {
    //         positionX: "right",
    //         positionY: "none",
    //         bleed: true,
    //         fileName: "003_Rainbow-Kombucha-Tap-With-Mug.png"
    //     }
    // },
    {
        id: "22",
        title: "The perfect color does not exist unless it comes in the shade of __________.",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "23",
        title: "Explain art direction like we're ninety-nine.",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "none",
            bleed: false,
            fileName: "011_Grandma-Looking-At-Computer.jpg"
        }
    },
    {
        id: "24",
        title: "What's your secret place?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "25",
        title: "Sell us your planet.",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "26",
        title: "You have gained the power of flight for 24 hrs. What does your itinerary look like?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: true,
            fileName: "012_Swift_Max.png",
            rotate: 45
        },
        customClass: "max"
    },
    {
        id: "27",
        title: "What's your circus act?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "28",
        title: "You can live anywhere (basic needs like money, food, etc. don't apply)—where are you headed?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "29",
        title: "What song is playing inside your head right now?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "30",
        title: "What's the best human-animal hybrid?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "31",
        title: "You can only follow one Twitter account. Who gets the honor?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "32",
        title: "You're on an island with no one else. You have nothing. But there's a payphone and you have one quarter. Who do you call?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: true,
            fileName: "013_Palm.png",
            rotate: -45
        }
    },
    {
        id: "33",
        title: "You're giving a T.E.D. talk. What's it about?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "34",
        title: "Monkeys no longer come by the barrel. What explains this disruption in monkey business?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    // {
    //     id: "checkpoint2",
    //     title: "Infinity is a concept not a requirement.",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: ""
    // },
    // {
    //     id: "35",
    //     title: "The sky is falling. What do you do?",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "highest",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "below",
    //         bleed: false,
    //         fileName: "014_Cloud.png"
    //     }
    // },
    {
        id: "36",
        title: "What should be the next new emoji?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "37",
        title: "How many tabs are open in your brain right now?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "38",
        title: "Rename spoon, fork and knife.",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "39",
        title: "Tell us a weird flex about you.",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "196",
        title: "What happened?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "above",
            bleed: false,
            fileName: "pinwheel.gif"
        }
    },
    {
        id: "41",
        title: "How much glitter is too much glitter?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "42",
        title: "What's a question you have for r/askreddit?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    // {
    //     id: "43",
    //     title: "Are you almost done?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "highest",
    //     value: ""
    // },
    {
        id: "44",
        title: "If money doesn't grow on trees, where does it grow?",
        type: "textarea",
        align: "right",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "45",
        title: "What's your most unusual skill?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "46",
        title: "You're creating a sculpture for the Louvre. What's your medium?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "48",
        title: "Who are you thanking in your acceptance speech?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "50",
        title: "Two roads diverged in the woods. What does the one on the right look like?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "51",
        title: "If you could take any Buzzfeed quiz (real or imaginary), what would it determine?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "52",
        title: "What should the Google Doodle be on August 3rd?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "53",
        title: "Name your own cereal brand.",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: true,
            fileName: "016_cereal.png",
            rotate: 15
        }
    },
    {
        id: "54",
        title: "You built a robot. What does it do?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "55",
        title: "How do you make yourself go viral on TikTok?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "56",
        title: "What part of an animal cracker do you eat first?",
        type: "textarea",
        align: "right",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "57",
        title: "What color can't you live without?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    // {
    //     id: "58",
    //     title: "Do you have patience?",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "max",
    //     value: ""
    // },
    // {
    //     id: "checkpoint3",
    //     title: "Keep going and going and going! Until you feel like submitting, that is.",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "above",
    //         fileName: "Hey Drink Water Giphy.gif",
    //         bleed: false
    //     }
    // },
    {
        id: "59",
        title: "It rains every day for a month. How do you maintain a sunny outlook?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "60",
        title: "What's the theme of your 2020 Halloween party?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "none",
            bleed: true,
            fileName: "glitter ghost.gif",
            rotate: 20
        }
    },
    {
        id: "61",
        title: "Who should host a Reddit AMA?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "62",
        title: "You're having dessert in a desert. What are you eating?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "center",
            positionY: "above",
            bleed: false,
            fileName: "sunglasses.gif"
        }
    },
    {
        id: "63",
        title: "Your Instagram Story is 25 frames (and growing.) What's it about?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "64",
        title: "Money can't buy happiness. But it sure can buy ______.",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "65",
        title: "What's an underrated skill?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "66",
        title: "Crumpets and tea break up. Who are their new partners?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    // {
    //     id: "67",
    //     title: "Have you seen this?",
    //     type: "textarea", // VIDEO
    //     align: "left",
    //     belowSpacing: "high",
    //     value: ""
    // },
    {
        id: "68",
        title: "What's the best decision you ever made?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "69",
        title: "You're only allowed to use three design programs for 6 months at your new gig. Which ones do you choose?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "70",
        title: "1:37PM is the best time for...",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "71",
        title: "You're on the cover of Vogue. What are you wearing?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "72",
        title: "Monday, Thursday and Friday feel left out thanks to Taco Tuesday and Wing Wednesday. What do you do to make them feel better?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "73",
        title: "What's your podcast about?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "74",
        title: "Explain design like I'm five.",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    // {
    //     id: "75",
    //     title: "Did you double check all your answers?",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "higher",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "below",
    //         bleed: false,
    //         fileName: "018_Eyes-Looking-Up.png"
    //     }
    // },
    {
        id: "76",
        title: "What do you see?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "above",
            bleed: false,
            fileName: "034_Rorschach.png"
        }
    },
    {
        id: "77",
        title: "What do you sell to a snake oil salesman?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "78",
        title: "How do you turn a fish into a starfish?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "79",
        title: "There's a new service called \"Shoe's On the Other Foot\". What do they do?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "197",
        title: "What song deserves a remix?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "80",
        title: "What’s the best human name for a guinea pig?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: false,
            fileName: "019_Guinea-Pig.png"
        }
    },
    // {
    //     id: "checkpoint4",
    //     title: "We’re not counting questions, just creativity.",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: ""
    // },
    {
        id: "81",
        title: "What’s an obscure thing you think history classes should teach?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "82",
        title: "How would you design the ideal meeting space?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "83",
        title: "What’s the weirdest word you could say to a stranger without context?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "84",
        title: "You just woke up as a fruit or vegetable at your local grocer. Which produce item are you?",
        type: "textarea",
        align: "left",
        belowSpacing: "highest",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "below",
            bleed: true,
            fileName: "020_Apple-With-Googly-Eyes.png"
        }
    },
    // {
    //     id: "85",
    //     title: "Why are you still answering these questions?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "higher",
    //     value: ""
    // },
    {
        id: "86",
        title: "There’s east, west, north and south. What’s another way you can go?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "87",
        title: "BOGSAT: What’s it stand for?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "88",
        title: "Argue your side: Cereal is a soup or cereal is a stew.",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "89",
        title: "You can talk to animals. What’s the first question you ask?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "90",
        title: "What’s the most moderately entertaining movie to exist?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "91",
        title: "Your mole starts talking to you. What do you do?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "92",
        title: "Are you sure you don’t want to go back and check your answers?",
        type: "textarea",
        align: "right",
        belowSpacing: "higher",
        value: "",
        sticker: {
            positionX: "center",
            positionY: "below",
            bleed: false,
            fileName: "032_Eyes-Looking-Up-Three.png"
        }
    },
    {
        id: "93",
        title: "Caption this.",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "above",
            bleed: false,
            fileName: "035_Centipants.jpg"
        }
    },
    {
        id: "94",
        title: "Name your new wave punk sax band.",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "above",
            bleed: false,
            fileName: "dancing cat.gif"
        }
    },
    {
        id: "95",
        title: "What makes a typeface good or bad?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "96",
        title: "What creature best embodies your personality?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "97",
        title: "Where is Sasquatch hiding?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "center",
            positionY: "above",
            bleed: false,
            fileName: "022_Mountain.png"
        },
        customClass: "mountains"
    },
    {
        id: "98",
        title: "What do you draw on your airplane wings?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "99",
        title: "Why are you eating wax?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "100",
        title: "Who is Tom Foolery?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "101",
        title: "Clap your hands. Whose face is there when you look?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "102",
        title: "What’s your r/nosleep entry?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: "",
        customClass: "ghost"
    },
    // {
    //     id: "checkpoint5",
    //     title: "Submit now! Or later! Or at noon! Or whenever you feel creatively fulfilled!",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "above",
    //         fileName: "Yes Giphy.gif",
    //         bleed: false
    //     }
    // },
    {
        id: "103",
        title: "The world is now run by yogurt. What flavor is it?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "104",
        title: "How do you fish for stars?",
        type: "textarea",
        align: "right",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "105",
        title: "If there are hot dogs, what are cold dogs?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "center",
            positionY: "below",
            bleed: false,
            fileName: "023_Baxter.png"
        }
    },
    {
        id: "106",
        title: "What kind of designs does your tattoo parlor specialize in?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "107",
        title: "Karaoke and you’re up. What happens next?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "above",
            bleed: false,
            fileName: "squirrel guitar.gif"
        }
    },
    {
        id: "108",
        title: "The writing’s on the wall. What does it say?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "110",
        title: "You just woke up out of a cryogenic chamber 150 years from now in time to attend your first art show in ages, only to find out the artist is....you! What work is the show stopping piece in your gallery?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "111",
        title: "You can time travel for one day. What time is it?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "below",
            bleed: false,
            fileName: "024_BacktotheFuture-Car.png"
        }
    },
    {
        id: "112",
        title: "What’s the best way to keep a poker face?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "113",
        title: "If you’re not a sneakerhead, you’re a _____.",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "114",
        title: "What’s the best way to celebrate National Pig Day?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "115",
        title: "Follow the lights. Where do they take you?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "116",
        title: "Are you good at really looooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooong applications?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "none",
            bleed: false,
            fileName: "hourglass.gif"
        }
    },
    {
        id: "117",
        title: "You’re president of your own country. Who’s singing at your inauguration?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "118",
        title: "What’s in your sticker pack?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "119",
        title: "Are elephants afraid of bees?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "120",
        title: "What’s the best recurring dream you could hope for?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "none",
            bleed: true,
            fileName: "psychodelic cat.gif"
        }
    },
    {
        id: "121",
        title: "A talking cheeseburger appears on your plate and you are hungry. Do you eat it?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "122",
        title: "Who let the dogs out?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: false,
            fileName: "036_Chacha.png"
        },
        customClass: "chacha"
    },
    {
        id: "123",
        title: "What’s at the bottom of the ocean?",
        type: "textarea",
        align: "right",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "124",
        title: "You would win the title of “Most Likely to ______.”",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    // {
    //     id: "126",
    //     title: "What are the five things you show to an alien race to prove humans are worth saving?",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "low",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "above",
    //         bleed: false,
    //         fileName: "gummy worms.gif"
    //     }
    // },
    // {
    //     id: "checkpoint6",
    //     title: "Here in the void you only have to answer as many questions as you like.",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: "",
    // },
    {
        id: "127",
        title: "What’s the one thing you hope never ends?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    // {
    //     id: "128",
    //     title: "Create a recipe for disaster.",
    //     type: "textarea",
    //     align: "right",
    //     belowSpacing: "high",
    //     value: "",
    //     sticker: {
    //         positionX: "left",
    //         positionY: "above",
    //         bleed: false,
    //         fileName: "026_Chicken-Nuggets.gif"
    //     }
    // },
    {
        id: "129",
        title: "You’re stuck in a loop. What’s the best part?",
        type: "textarea",
        align: "right",
        belowSpacing: "highest",
        value: ""
    },
    {
        id: "130",
        title: "How low can you go?",
        type: "textarea",
        align: "left",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "131",
        title: "How many feet are there in the world?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "133",
        title: "Write a horoscope for your favorite celebrity. We will know if you copied it from @notallgeminis.",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "134",
        title: "What’s something we’ll find only in your head?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: false,
            fileName: "032_Don-vs-Don.png"
        },
        customClass: "don-vs-don"
    },
    {
        id: "135",
        title: "The internet is down. Now what?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "136",
        title: "What’s the last mind-blowing thing you learned?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    // {
    //     id: "137",
    //     title: "But really, what’s compelling you to keep going with this application?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "medium",
    //     value: ""
    // },
    {
        id: "138",
        title: "Costume change! What’s up next?",
        type: "textarea",
        align: "center",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "139",
        title: "What niche group has taken a liking to your YouTube channel?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "140",
        title: "What’s in your dream buffet?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "center",
            positionY: "below",
            bleed: false,
            fileName: "027_Donut.gif"
        }
    },
    {
        id: "141",
        title: "Clean up on aisle 23,757. What’s the mess?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "142",
        title: "🦄💫🤐🤸‍♀️🤯 What’s the story here?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "143",
        title: "You see a unicorn and a talking dog but only have time to engage with one. Which do you choose?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    // {
    //     id: "144",
    //     title: "Why are you still going?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: ""
    // },
    {
        id: "145",
        title: "You are a key on a keyboard. Which key are you?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "198",
        title: "If the world revolves around you, how long is a year?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "146",
        title: "What’s so funny?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    // {
    //     id: "147",
    //     title: "What do you have stocked in your subterranean bunker fridge?",
    //     type: "textarea",
    //     align: "right",
    //     belowSpacing: "medium",
    //     value: ""
    // },
    {
        id: "148",
        title: "How do you check for monsters under the bed?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    // {
    //     id: "checkpoint7",
    //     title: "Creativity > Quantity (AKA submit when you’re ready)",
    //     type: "checkpoint",
    //     align: "center",
    //     belowSpacing: "high",
    //     value: "",
    //     sticker: {
    //         positionX: "center",
    //         positionY: "above",
    //         fileName: "You Got This Giphy.gif",
    //         bleed: false
    //     }
    // },
    {
        id: "149",
        title: "What is a space jam?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "150",
        title: "You can make pancakes in any shape. What’s on your breakfast plate?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: false,
            fileName: "028_Pizza.png"
        }
    },
    {
        id: "151",
        title: "Always go under the speed limit. But over the ____ limit.",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "152",
        title: "What are non-traditional ways to use a chair?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "153",
        title: "If you had 4 + 5 + 2 - 3(35 x 35) / 3 - 4 + 10(5-3) of a pie laced with expired shellfish and you fed it to the Demogorgon in the real world, how much of a pie would you have left in the upside down world when it pukes it out?",
        type: "textarea",
        align: "right",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "154",
        title: "Dracula’s sunscreen lets him come out during the day.  How do you welcome him back into normal human society?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "155",
        title: "What do you draw on every apple in the orchard?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "below",
            bleed: false,
            fileName: "034_Multiple_Apples.png"
        }
    },
    {
        id: "156",
        title: "What’s the opposite of stranger danger?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "157",
        title: "You’re handed a blank piece of paper. What do you do?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "158",
        title: "If you had to draw a map of the stars, what symbol would represent Bruce Willis?",
        type: "textarea",
        align: "left",
        belowSpacing: "higher",
        value: ""
    },
    // {
    //     id: "159",
    //     title: "How many more questions do you think there are?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "highest",
    //     value: ""
    // },
    {
        id: "160",
        title: "What’s your horoscope for thirteen years and three weeks from next Tuesday?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "161",
        title: "You’re one of the pieces in a museum exhibit. What does the placard say about you?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "162",
        title: "What’s the historically inaccurate reason for calling a sandwich, a sandwich?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "163",
        title: "Someone lights a fire under your butt. Why?",
        type: "textarea",
        align: "left",
        belowSpacing: "medium",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: false,
            fileName: "030_Peach.png"
        },
        customClass: "peach"
    },
    {
        id: "164",
        title: "Do turtles find turtlenecks offensive? Why?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: "",
    },
    {
        id: "199",
        title: "What do you think you're overthinking about?",
        type: "textarea",
        align: "left",
        belowSpacing: "higher",
        value: "",
    },
    {
        id: "165",
        title: "You have a new pet parrot which you have to take around everywhere in life, i.e. Your proposal, your wedding, family dinners, family breakfasts, holidays, work, the street, the ice cream parlor, parent teacher conferences, the park, the gym, the DMV. What is the one thing you teach your pet parrot to say?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "166",
        title: "We all scream for _______.",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "167",
        title: "What do you do in a world without smartphones?",
        type: "textarea",
        align: "right",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "168",
        title: "If you’re not a liar, justify the reason for your pants being on fire.",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "below",
            bleed: true,
            fileName: "029_Fire.png"
        }
    },
    {
        id: "169",
        title: "Which Brad is the best Brad?",
        type: "textarea",
        align: "center",
        belowSpacing: "higher",
        value: ""
    },
    // {
    //     id: "checkpoint8",
    //     title: "You can shoot for the stars, but you don’t have to shoot EVERY star. (That’s a metaphor for these questions).",
    //     type: "checkpoint",
    //     align: "left",
    //     belowSpacing: "high",
    //     value: ""
    // },
    {
        id: "200",
        title: "What's up?",
        type: "textarea",
        align: "center",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "170",
        title: "Someone challenges you to a duel. How do you get out of it and still protect your honor?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "171",
        title: "What do you sell at your intergalactic hardware store?",
        type: "textarea",
        align: "right",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "172",
        title: "Take a spin in your chair. What’s the first thing that pops into your head?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    // {
    //     id: "173",
    //     title: "What do you think is at the end?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "highest",
    //     value: ""
    // },
    // {
    //     id: "174",
    //     title: "Is there even an end?",
    //     type: "textarea",
    //     align: "center",
    //     belowSpacing: "max",
    //     value: ""
    // },
    {
        id: "175",
        title: "What’s in the sneak preview of the trailer to your life?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "176",
        title: "What’s something everyone should have an irrational happiness for?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "177",
        title: "Everyone’s staring at you. What did you do?",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "179",
        title: "What is a snack attack?",
        type: "textarea",
        align: "center",
        belowSpacing: "low",
        value: "",
        sticker: {
            positionX: "left",
            positionY: "none",
            bleed: false,
            fileName: "cheeto.gif"
        },
        customClass: "cheeto"
    },
    {
        id: "180",
        title: "Write a haiku about infinity.",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    // {
    //     id: "181",
    //     title: "Your turn. Ask us anything.",
    //     type: "textarea",
    //     align: "left",
    //     belowSpacing: "low",
    //     value: ""
    // },
    {
        id: "182",
        title: "In your dresser you discover a smaller dresser. What’s inside the smaller dresser?",
        type: "textarea",
        align: "left",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "183",
        title: "You are immortal. How do you spend eternity?",
        type: "textarea",
        align: "center",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "184",
        title: "Are you the original or the clone?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "185",
        title: "What does the voice of a rainbow sound like?",
        type: "textarea",
        align: "center",
        belowSpacing: "higher",
        value: "",
        sticker: {
            positionX: "center",
            positionY: "above",
            bleed: false,
            fileName: "Voice of rainbow.gif"
        }
    },
    {
        id: "202",
        title: "Who wins?",
        type: "textarea",
        align: "left",
        belowSpacing: "higher",
        value: "",
        sticker: {
            positionX: "right",
            positionY: "none",
            bleed: false,
            fileName: "033_Pong.gif"
        }
    },
    {
        id: "186",
        title: "To what platform would you upload your consciousness?",
        type: "textarea",
        align: "right",
        belowSpacing: "highest",
        value: ""
    },
    {
        id: "187",
        title: "What is love?",
        type: "textarea",
        align: "left",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "188",
        title: "Tweet like you’re Cher in an alternate universe.",
        type: "textarea",
        align: "left",
        belowSpacing: "low",
        value: ""
    },
    {
        id: "189",
        title: "Who are you?",
        type: "textarea",
        align: "center",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "190",
        title: "Is infinity a number or a magnitude?",
        type: "textarea",
        align: "right",
        belowSpacing: "medium",
        value: ""
    },
    {
        id: "192",
        title: "What’s the protocol for a reality check?",
        type: "textarea",
        align: "center",
        belowSpacing: "high",
        value: ""
    },
    {
        id: "193",
        title: "Take a moment to wildly speculate.",
        type: "textarea",
        align: "center",
        belowSpacing: "higher",
        value: ""
    },
    {
        id: "194",
        title: "Who has all the answers?",
        type: "textarea",
        align: "center",
        belowSpacing: "highest",
        value: ""
    },
    {
        id: "195",
        title: "Have we missed anything?",
        type: "textarea",
        align: "center",
        belowSpacing: "end",
        value: ""
    }
];

export { requiredQuestions, otherQuestions };